import { render, staticRenderFns } from "./RetentionRuleValidationsModal.vue?vue&type=template&id=2d0e206e&"
import script from "./RetentionRuleValidationsModal.vue?vue&type=script&lang=js&"
export * from "./RetentionRuleValidationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports